import { FC } from "react";
import {
  ToggleButton,
  ToggleButtonGroup,
  Box,
  Typography,
} from "@mui/material";
import { Straighten, Public } from "@mui/icons-material";
import { MeasurementSystem } from "../../utils/measurementConversions";
import { Stack } from "@mui/system";

interface MeasurementSystemToggleProps {
  system: MeasurementSystem;
  onChange: (system: MeasurementSystem) => void;
}

export const MeasurementSystemToggle: FC<MeasurementSystemToggleProps> = ({
  system,
  onChange,
}) => {
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newSystem: MeasurementSystem,
  ) => {
    if (newSystem !== null) {
      onChange(newSystem);
    }
  };

  return (
    <Stack spacing={1}>
      <Typography variant="body2" fontWeight="bold">
        Measurement System:
      </Typography>
      <ToggleButtonGroup
        value={system}
        exclusive
        onChange={handleChange}
        size="small"
        sx={{
          "& .MuiToggleButton-root": {
            px: 2,
            py: 0.5,
            minWidth: "auto",
          },
        }}
        color="primary"
      >
        <ToggleButton value="US" aria-label="US customary units">
          <Straighten sx={{ mr: 0.5, fontSize: "1rem" }} />
          US
        </ToggleButton>
        <ToggleButton value="METRIC" aria-label="Metric units">
          <Public sx={{ mr: 0.5, fontSize: "1rem" }} />
          Metric
        </ToggleButton>
      </ToggleButtonGroup>
      <Typography variant="caption" color="text.secondary">
        {system === "US" ? "(inches, pounds)" : "(centimeters, kilograms)"}
      </Typography>
    </Stack>
  );
};
